var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03764 4.25501C6.03742 4.69875 5.86093 5.12422 5.54701 5.43784C5.23308 5.75145 4.80743 5.92751 4.36369 5.92729C3.91995 5.92707 3.49447 5.75058 3.18086 5.43665C2.86725 5.12273 2.69118 4.69707 2.69141 4.25334C2.69163 3.8096 2.86812 3.38412 3.18204 3.07051C3.49597 2.75689 3.92162 2.58083 4.36536 2.58105C4.8091 2.58128 5.23457 2.75776 5.54819 3.07169C5.8618 3.38562 6.03786 3.81127 6.03764 4.25501V4.25501ZM6.08784 7.16623H2.7416V17.64H6.08784V7.16623ZM11.3749 7.16623H8.04538V17.64H11.3414V12.1438C11.3414 9.08195 15.3318 8.79752 15.3318 12.1438V17.64H18.6362V11.006C18.6362 5.84447 12.7301 6.03688 11.3414 8.57165L11.3749 7.16623V7.16623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.24bab103fa9bd05cced848b0582fdeb8.svg";
export { ForwardRef as ReactComponent };